import * as gs from "@ivanlog/gs";
import { StateDashboard } from "./states/StateDashboard";
import { StateGS } from "@ivanlog/gs";
import { StateApp as StateApp } from "../plusx-lib/states/abstracts/StateApp";
import { StateLoading } from "./states/StateLoading";
import { App } from "../plusx-lib/App";
import { GUIControllerBase } from "../plusx-lib/controllers/GUIControllerBase";
import { VXInfrastructure } from "../plusx-lib/contracts/VXInfrastructure";
import { CmpFooterLPX } from "../plusx-lib/com/tmpls";
import { LPXInfrastructure } from "../plusx-lib/contracts/LPXInfrastructure";
import { ChainControllerBase } from "../plusx-lib/controllers/ChainControllerBase";


export class AppLPX extends App {
    public static Inst: AppLPX;
    public static get GUI() { return AppLPX.Inst._gui; }
    public static get Chain() { return AppLPX.Inst._chain; }

    public static Version = "0.12.20"
    public static CHAIN_RPC:string="https://rpc.pulsechain.com"
    //public static CHAIN_RPC:string="https://rpc.v4.testnet.pulsechain.com"
    public static CHAIN_ID:number=369;


    private _gui: GUIControllerBase;    
    private _chain: ChainControllerBase;
   

    constructor() {
        super(AppLPX.Version);

        AppLPX.Inst=this;
        StateApp.App = this;
        StateGS.DefaultStateName = StateDashboard.StateName;     
        ChainControllerBase.TermMessage="Please confirm that you have read and agree to the <a href=\"https://up.docs.plusx.app/?folder=LPX&article=Terms%20of%20Use%20LPX\" target='_blank'>Terms of Use</a> by clicking the button below.";
    }

    protected async startAsync() {

        this._gui = new GUIControllerBase(this); this.addInst(GUIControllerBase, this._gui);
        this._chain = new ChainControllerBase(this, AppLPX.CHAIN_ID, AppLPX.CHAIN_RPC); this.addInst(ChainControllerBase, this._chain);

        this._gui.setFooter(new CmpFooterLPX());

        await super.startAsync();

        StateGS.RegState(StateLoading); 
        StateGS.RegState(StateDashboard);     

        await this._gui.startAsync();
        await StateGS.Run(StateLoading);
        await this._chain.startAsync();

        const lpxInf=new LPXInfrastructure();
        let loaded=false;
        if (this._chain.isConnected) loaded = await lpxInf.initializeAsync(this._chain.provider);
        if (loaded)
        { 
            this.addInst(LPXInfrastructure, lpxInf);
          //  const byUrl = await StateGS.RunByUrl()
          //  if (byUrl === StateRunResultEnum.Failed) 
            await StateGS.Run(StateDashboard); 
        } else 
        { 
            await StateGS.Run(StateLoading); 
        }
    }

    public awaitTime(timeMS:number):Promise<void>
    {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>resolve(), timeMS);
        })
    }

   
}
